import api from 'utils/apiRest'

export const getAvailableSessionsToRegister = () => api.get('/supervisions/available-sessions-to-register-on')
